import React from 'react';
import PropTypes from 'prop-types';
import css from './Footer.css';

export default class Footer extends React.Component {

  render() {
    return (
      <footer className={`${css['container']} ${this.props.className || ''}`}>
        {this.props.secondaryButton}
        {this.props.optionalMiddleButton}
        {this.props.primaryButton}
      </footer>
    );
  }
}

Footer.propTypes = {
  primaryButton: PropTypes.object.isRequired,
  secondaryButton: PropTypes.object,
  optionalMiddleButton: PropTypes.object,
  className: PropTypes.string
};
